// extracted by mini-css-extract-plugin
export default {"wrapperft":"Main_wrapperft__wnI7Y","push":"Main_push__aWjej","full_blue":"Main_full_blue__XLEmL"};